export const typeProducProfileRoles = {OtherProducts: "OtherProducts", MainProduct: "MainProduct"}
export const typeProduct = {OUTROS:"OUTROS", PRINCIPAL: "PRINCIPAL"}

export const mountTypeProductCriteria = (userRoles: string[]) => {
    //Tratar telas de financeiro, Cargas concluidas e arquivadas
    //Para pessoas do financeiro, caso pague todos os processos, será necessário marcar as duas roles Fabrie e Outros

    //Se tem Principal, retorna  Principal ou nulo
    if (userRoles.includes(typeProducProfileRoles.MainProduct) && !userRoles.includes(typeProducProfileRoles.OtherProducts)) {
        return {
            $or: [
                { productType: typeProduct.PRINCIPAL },
                { productType: { $exists: false } },
                { productType: null }
            ]
        }
    }
    //Se user tem AMBOS, retorna Ambos ou nulo (TUDO)
    if (userRoles.includes(typeProducProfileRoles.MainProduct) && userRoles.includes(typeProducProfileRoles.OtherProducts)) {
        return {
            $or: [
                { productType: { $in: [typeProduct.PRINCIPAL, typeProduct.OUTROS] } },
                { productType: { $exists: false } },
                { productType: null }
            ]
        }

    }

    //Se user tem Outros, retorna produto Outros ou nulo
    if (!userRoles.includes(typeProducProfileRoles.MainProduct) && userRoles.includes(typeProducProfileRoles.OtherProducts)) {
        return {
            $or: [
                { productType: typeProduct.OUTROS },
                { productType: { $exists: false } },
                { productType: null }
            ]
        }
    }

    //Se o usuário não tem nenhuma role, retorna produto principal ou nulo
    if (!userRoles.includes(typeProducProfileRoles.MainProduct) && !userRoles.includes(typeProducProfileRoles.OtherProducts)) {
        return {
            $or: [
                { productType: typeProduct.PRINCIPAL },
                { productType: { $exists: false } },
                { productType: null }
            ]
        }
    }


}